import React from 'react';
import { Box, Typography } from '@mui/material';

interface LayoutProps {
  title: string;
  children: React.ReactNode;
}

const ListFormLayout: React.FC<LayoutProps> = ({ title, children }) => {
  return (
    <Box sx={{backgroundColor: "#FFF8F8"}}>
      <Typography variant="h4" sx={{ marginBottom: '16px', marginLeft: '16px', marginTop: '16px' }}>
        {title}
      </Typography>
      <Box>
        {children}
      </Box>
    </Box>
  );
};

export default ListFormLayout;